import { useActionData } from 'react-router'

import { AppActionData } from '~/root.action'
import { LandingPagePreviewActionData } from '~/types/preview'

export const usePreviewData = (): LandingPagePreviewActionData => {
  const { previewData, isPreview = false } = useActionData<AppActionData>() || {}

  return ({ previewData, isPreview })
}